//External libraries
import styled from '@emotion/styled';

// Internal modules
import {
  FONT_SIZE_SMALL,
  LANG_COUNTRY_DIVIDER_COLOR,
  PRIMARY_COLOR_V2,
} from '@/styles/styleVariables';
import { getLinkStateStyles } from '@/components/Common';
import { bodyMediumStyles } from '@/styles/fontRebrandingStyles';

const LanguageButton = styled.button`
  background-color: transparent;
  border: 0;
  color: ${PRIMARY_COLOR_V2};
  cursor: pointer;
  font-size: ${FONT_SIZE_SMALL};
  line-height: 20px;
  padding: 0 7.5px;

  ${({ theme }) => getLinkStateStyles(theme)}

  &:hover, &:focus {
    text-decoration: underline;
  }

  .overrides-font-4-2 & {
    ${bodyMediumStyles}
  }
`;

const LanguageListContainer = styled.div`
  display: flex;
  padding-right: 12px;

  &::after {
    background-color: ${LANG_COUNTRY_DIVIDER_COLOR};
    content: '';
    left: 5px;
    margin-right: 1px;
    position: relative;
    width: 1px;
  }
`;

export { LanguageListContainer, LanguageButton };
